import {
  // broadcastUpdate,
  updateUser,
  updatePaymentCards,
  updateNocTasks,
  updateNotaryUserForms,
  addURL,
  addUserFullDesignProfessionals,
  setInstantRonAccepted,
  setInstantRonStop,
  setInstantRonSuccess,
  updateAnalytics,
  update_discount_data,
} from "../userActions";

import {
  getLiveNocData,
  getPdfProgress,
  loadSubAdminData,
  updatePermitPackageFromReturn,
  updatePermitPackageOnFly,
  pushCityLog,
  updateUserPackageOnFly,
} from "../dataActions";
import { updateNocNotification } from "../notificationsActions";
import { handleSessionExpiredLogout } from "../sessionsActions";
import { mergeSelectedCountiesById } from "../../../utils/stateUtils";

export const userSessionOnMessage =
  (receivedData) => async (dispatch, getState) => {
    switch (receivedData.event) {
      case "logout":
        dispatch(handleSessionExpiredLogout());
        break;
      case "instant_ron_accepted":
        const ronAcceptedUpdate = receivedData.data;
        if (ronAcceptedUpdate.success === true) {
          dispatch(setInstantRonAccepted());
          break;
        } else if (ronAcceptedUpdate.success === "stop") {
          dispatch(setInstantRonStop());
          break;
        } else if (ronAcceptedUpdate.success === "success") {
          dispatch(setInstantRonSuccess());
          break;
        }
        break;
      case "noc_notification_update":
        dispatch(
          updateNocNotification(
            receivedData.data.new_notification,
            receivedData.data.notification_counts,
          ),
        );
        break;
      case "user_update":
        dispatch(
          updateUser({
            ...receivedData?.data,
            user: {
              ...receivedData?.data.user,
              selectedCountiesNOC: mergeSelectedCountiesById(
                receivedData?.data.user.selectedCountiesNOC,
                receivedData?.data.displays.county_cards,
              ),
            },
          }),
        );
        break;
      case "update_notary_user_forms":
        dispatch(updateNotaryUserForms(receivedData.data));
        break;
      case "update_payment_cards":
        dispatch(updatePaymentCards(receivedData?.data));
        break;
      case "update_noc_tasks":
        dispatch(updateNocTasks(receivedData?.data));
        break;
      case "broadcast":
        dispatch(getLiveNocData(receivedData.data));
        break;
      case "add_url_img":
        dispatch(addURL(receivedData.data?.data));
        break;
      case "update_pdf_progress":
        dispatch(getPdfProgress(receivedData.data));
        break;
      case "design_professionals_update":
        dispatch(addUserFullDesignProfessionals(receivedData.data));
        break;
      case "update_permit_document":
        dispatch(updatePermitPackageFromReturn(receivedData.data));
        break;
      case "update_permit_package_on_fly":
        dispatch(updatePermitPackageOnFly(receivedData.data));
        break;
      case "update_user_package_on_fly":
        dispatch(updateUserPackageOnFly(receivedData.data));
        break;
      case "push_city_log":
        dispatch(pushCityLog(receivedData.data));
        break;
      case "update_analytics":
        dispatch(updateAnalytics(receivedData.data));
        break;
      case "discount_update":
        dispatch(update_discount_data(receivedData.data));
        break;
      case "sub_admins_data_update":
        dispatch(loadSubAdminData(receivedData.data));
        break;
      default:
        return;
    }
  };
